import React from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { InputSwitch } from "primereact/inputswitch";
import { Message } from "primereact/message";
import { MILE_TYPES } from "../TariffPlans/mileTypes";

export const SCOPES = [
  { value: "GLOBAL", label: "Для всех" },
  { value: "PARTNER", label: "Для партнёра" },
  { value: "PLAN", label: "Для тарифной карты" },
];

/**
 * Создание и правка закрытого направления.
 *
 * У каждого скоупа свой ключ, и без него блокировка либо не сработает, либо
 * сработает не там: «для карты» без карты молча стала бы глобальной. То же
 * условие проверяют калькулятор и база.
 */
const BlockDialog = ({ visible, onHide, onSubmit, loading, block, plans, services }) => {
  const [scope, setScope] = React.useState("GLOBAL");
  const [tariffPlanId, setTariffPlanId] = React.useState(null);
  const [platform, setPlatform] = React.useState("");
  const [clientName, setClientName] = React.useState("");
  const [originKato, setOriginKato] = React.useState("");
  const [destinationKato, setDestinationKato] = React.useState("");
  const [mileType, setMileType] = React.useState(null);
  const [psId, setPsId] = React.useState(null);
  const [reason, setReason] = React.useState("");
  const [isActive, setIsActive] = React.useState(true);

  const isEdit = Boolean(block);

  React.useEffect(() => {
    if (!visible) return;
    setScope(block?.scope ?? "GLOBAL");
    setTariffPlanId(block?.tariffPlanId ?? null);
    setPlatform(block?.platform ?? "");
    setClientName(block?.clientName ?? "");
    setOriginKato(block?.originKato ?? "");
    setDestinationKato(block?.destinationKato ?? "");
    setMileType(block?.mileType ?? null);
    setPsId(block?.psId ?? null);
    setReason(block?.reason ?? "");
    setIsActive(block?.isActive ?? true);
  }, [visible, block]);

  const missingKey =
    (scope === "PARTNER" && !platform.trim()) || (scope === "PLAN" && !tariffPlanId);
  const canSave = originKato.trim() && destinationKato.trim() && !missingKey;

  const handleSave = () => {
    if (!canSave) return;
    onSubmit({
      scope,
      tariffPlanId: scope === "PLAN" ? tariffPlanId : null,
      platform: scope === "PARTNER" ? platform.trim() : null,
      clientName: scope === "PARTNER" ? (clientName.trim() || null) : null,
      originKato: originKato.trim(),
      destinationKato: destinationKato.trim(),
      mileType: mileType ?? null,
      psId: psId ?? null,
      reason: reason.trim() || null,
      isActive,
    });
  };

  const footer = (
    <div>
      <Button label="Отмена" icon="pi pi-times" className="p-button-text" onClick={onHide} />
      <Button label="Сохранить" icon="pi pi-check" loading={loading} disabled={!canSave} onClick={handleSave} />
    </div>
  );

  const planOptions = (plans ?? []).map((p) => ({ label: p.name, value: p.id }));
  const serviceOptions = (services ?? []).map((s) => ({ label: s.label, value: s.psId }));

  return (
    <Dialog header={isEdit ? "Правка блокировки" : "Закрыть направление"}
            visible={visible} style={{ width: "640px" }} modal onHide={onHide} footer={footer}>
      <div className="p-fluid p-formgrid p-grid">
        <div className="p-field p-col-12 p-md-6">
          <label>Кого закрывает</label>
          <Dropdown value={scope} options={SCOPES} onChange={(e) => setScope(e.value)} />
        </div>

        {scope === "PLAN" && (
          <div className="p-field p-col-12 p-md-6">
            <label>Тарифная карта</label>
            <Dropdown value={tariffPlanId} options={planOptions} filter
                      placeholder="Выберите карту" onChange={(e) => setTariffPlanId(e.value)} />
            <small className="p-d-block">Закрыто для тех, кому эта карта назначена.</small>
          </div>
        )}

        {scope === "PARTNER" && (
          <>
            <div className="p-field p-col-12 p-md-6">
              <label>Платформа</label>
              <InputText value={platform} onChange={(e) => setPlatform(e.target.value)}
                         placeholder="например, HALYK" />
            </div>
            <div className="p-field p-col-12 p-md-6">
              <label>Клиент</label>
              <InputText value={clientName} onChange={(e) => setClientName(e.target.value)}
                         placeholder="все клиенты платформы" />
              <small className="p-d-block">Пусто — закрыто для всех клиентов платформы.</small>
            </div>
          </>
        )}

        <div className="p-field p-col-12 p-md-6">
          <label>КАТО отправления</label>
          <InputText value={originKato} onChange={(e) => setOriginKato(e.target.value)}
                     placeholder="710000000" />
        </div>

        <div className="p-field p-col-12 p-md-6">
          <label>КАТО доставки</label>
          <InputText value={destinationKato} onChange={(e) => setDestinationKato(e.target.value)}
                     placeholder="750000000" />
        </div>

        <div className="p-field p-col-12 p-md-6">
          <label>Плечо</label>
          <Dropdown value={mileType} options={MILE_TYPES} showClear placeholder="Любое плечо"
                    onChange={(e) => setMileType(e.value)} />
        </div>

        <div className="p-field p-col-12 p-md-6">
          <label>Услуга</label>
          <Dropdown value={psId} options={serviceOptions} filter showClear placeholder="Любая услуга"
                    onChange={(e) => setPsId(e.value)} />
        </div>

        <div className="p-field p-col-12">
          <label>Причина для клиента</label>
          <InputText value={reason} onChange={(e) => setReason(e.target.value)}
                     placeholder="например, паводок" />
          <small className="p-d-block">
            Этот текст увидит клиент вместо цены. Пусто — покажем общий текст «доставка временно недоступна».
          </small>
        </div>

        <div className="p-field p-col-12 p-md-6">
          <label>Блокировка включена</label>
          <div>
            <InputSwitch checked={isActive} onChange={(e) => setIsActive(e.value)} />
          </div>
          <small className="p-d-block">Выключите, чтобы открыть направление, не удаляя правило.</small>
        </div>

        {missingKey && (
          <div className="p-col-12">
            <Message severity="error"
                     text={scope === "PLAN"
                       ? "Выберите тарифную карту: иначе блокировка стала бы глобальной."
                       : "Укажите платформу: иначе блокировка стала бы глобальной."} />
          </div>
        )}
      </div>
    </Dialog>
  );
};

export default BlockDialog;
